<template>
  <div>
    <login-header v-bind="headerInfo" :userDisplayFlag="false"></login-header>
    <div class="content">
      <div class="activation-code">{{ activationCode }}</div>
      <div class="activation-btn" @click="copy(activationCode)"></div>
      <img
        src="https://img-shop.qmimg.cn/s1001016/images/2020/05/14/76c99798e872b4dd.png"
        width="100%"
        draggable="false"
      />
    </div>
    <login-footer :description="desc"></login-footer>
  </div>
</template>

<script>
import loginHeader from '../header'
import loginFooter from '../footer'
import qs from 'qs'
import Clipboard from 'clipboard'

export default {
  components: {
    loginHeader,
    loginFooter
  },
  data() {
    return {
      headerInfo: {
        type: '操作步骤',
        userDisplayFlag: true,
        userName: '',
        logo: ''
      },
      desc: '',
      activationCode: ''
    }
  },
  created() {
    const query = this.$route.query || {}
    this.activationCode = query.activation_code || ''
    if (!this.activationCode) {
      this.$router.replace({ path: `/index.html` })
      return
    }

    const mobile = localStorage.getItem('mobile')
    this.headerInfo.userName = mobile

    this.loginInfo = qs.parse(localStorage.getItem('xdata'))
    this.headerInfo.logo = this.loginInfo.logo
    this.desc = this.loginInfo.desc
  },
  methods: {
    copy(text) {
      const clipboardJS = new Clipboard('.activation-btn', {
        text: () => text
      })
      clipboardJS.on('success', () => {
        this.$message.success('复制激活码成功')
      })
    }
  }
}
</script>

<style scoped>
  .content {
    user-select: none;
    position: relative;
  }
  .activation-code {
    position: absolute;
    color: #a9a9a9;
    font-size: 22px;
    left: 465px;
    top: 289px;
  }
  .activation-btn {
    display: block;
    position: absolute;
    width: 200px;
    height: 77px;
    cursor: pointer;
    top: 262px;
    left: 258px;
    z-index: 100;
  }
</style>